import { T, useT } from "@repo/transifex";
import { MAX_SCALE_DECIMALS } from "~/utils/hardware/scale-precision";

type DecimalsSliderProps = {
  value: number;
  onChange: (decimals: number) => void;
};

/** The one control of the precision step: how many decimals the scale's display shows. */
export const DecimalsSlider = ({ value, onChange }: DecimalsSliderProps) => {
  const t = useT();

  return (
    <div className="flex w-full flex-col gap-3">
      <div className="flex items-center justify-between text-sm font-bold text-text-secondary">
        <span>
          <T _str="0 decimals" />
        </span>
        <span className="text-base text-text-primary">
          <T _str="{count} decimals" count={value} />
        </span>
        <span>
          <T _str="{count} decimals" count={MAX_SCALE_DECIMALS} />
        </span>
      </div>

      <input
        aria-label={t("Decimals shown by the scale")}
        className="h-3 w-full cursor-pointer accent-primary-main"
        max={MAX_SCALE_DECIMALS}
        min={0}
        onChange={(event) => {
          onChange(Number(event.target.value));
        }}
        step={1}
        type="range"
        value={value}
      />
    </div>
  );
};
